import { useEffect } from "react";
import { pushBeginCheckout, pushFunnelStep, pushViewCart } from "lib/gtm";
import { RefurbishedProduct } from "types/refurbishedProduct";
import { CartAddress } from "types/cart";
import useCart from "hooks/useCart";
import { getCartPrice } from "components/funnel/utils";

interface GTMPushFunnelStepProps {
  step: string;
  products: RefurbishedProduct[];
  address: CartAddress;
}

const GTMPushFunnelStep: React.FC<GTMPushFunnelStepProps> = ({ step, products, address }) => {
  const [cart] = useCart();
  const amount = getCartPrice(cart);

  useEffect(() => {
    pushFunnelStep(step, products, address?.zipcode);
    if (step === "1") pushViewCart(products, amount);
    if (step === "3") pushBeginCheckout(products, amount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default GTMPushFunnelStep;
